import * as React from 'react';
import * as classNames from 'classnames';
import * as globalStyles from 'styles/style.scss';
import * as styles from './styles.scss';
import { AccountDropdown, Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { getAssetInforDerivatives } from './actions';
import { withErrorBoundary } from 'react-error-boundary';
import config from 'config';
import { Refresh, InfoBuyIn } from 'assets/svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Portfolio from '../../Portfolio';
import RealizedPortfolio from '../../RealizedPortfolio';
import { enquiryPortfolio } from 'components/common/OrderForm/actions';

interface IAssetInforDerivativesProps
  extends React.ClassAttributes<AssetInforDerivativesComponent>,
    WithNamespaces,
    RouteComponentProps {
  readonly selectedAccount: IState['selectedAccount'];
  readonly assetInforDerivatives: IState['assetInforDerivatives'];
  readonly isSmallComponent?: boolean;

  readonly getAssetInforDerivatives: typeof getAssetInforDerivatives;
  readonly enquiryPortfolio: typeof enquiryPortfolio;
}

enum AssetInfoDerTabs {
  PORTFOLIO = 'PORTFOLIO',
  REALIZED_PORTFOLIO = 'REALIZED_PORTFOLIO',
}

interface IAssetInforDerivativesState {
  readonly activeTab: AssetInfoDerTabs;
}

class AssetInforDerivativesComponent extends React.Component<
  IAssetInforDerivativesProps,
  IAssetInforDerivativesState
> {
  constructor(props: IAssetInforDerivativesProps) {
    super(props);

    this.state = {
      activeTab: AssetInfoDerTabs.PORTFOLIO,
    };
  }

  componentDidMount() {
    if (this.props.selectedAccount != null) {
      if (this.props.selectedAccount.isBrokerCall) {
        this.props.getAssetInforDerivatives({
          accountNo: this.props.selectedAccount.accountNumber,
          clientID: this.props.selectedAccount.clientID,
        });
      } else {
        this.props.getAssetInforDerivatives({
          accountNo: this.props.selectedAccount.accountNumber,
        });
      }
    }
  }

  shouldComponentUpdate(nextProps: IAssetInforDerivativesProps) {
    if (
      this.props.selectedAccount !== nextProps.selectedAccount &&
      nextProps.selectedAccount !== null
    ) {
      if (nextProps.selectedAccount.isBrokerCall) {
        this.props.getAssetInforDerivatives({
          accountNo: nextProps.selectedAccount.accountNumber,
          clientID: nextProps.selectedAccount.clientID,
        });
      } else {
        this.props.getAssetInforDerivatives({
          accountNo: nextProps.selectedAccount.accountNumber,
        });
      }
    }
    return true;
  }

  render() {
    const { t, isSmallComponent } = this.props;
    const dataDerivatives = this.props.assetInforDerivatives.data;
    const derAccountSummary = dataDerivatives?.accountSummary;
    const derportfolio = dataDerivatives?.portfolioAssessment;
    const derCashInformation = dataDerivatives?.cashInformation;
    return isSmallComponent ? (
      <div className={styles.TabAssetInformationDer}>
        <div
          className={`${styles.TableDerivatives} ${styles.CashBarSectionMini}`}
        >
          <div className={styles.body}>
            <p>{t('Net Aset Value')}</p>
            <p>{formatNumber(derAccountSummary?.totalEquity)}</p>
          </div>
          <div className={styles.body}>
            <p>{t('EE')}</p>
            <p>
              {this.foundMinEE(
                derCashInformation?.internal.EE,
                derCashInformation?.exchange.EE
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('VSD Cash Withdrawable')}</p>
            <p>{formatNumber(derCashInformation?.exchange.cashWithdrawable)}</p>
          </div>
          <div className={styles.body}>
            <p>
              {t('Domain Cash WithDrawable', {
                domain: config.domain.toUpperCase(),
              })}
            </p>
            <p>{formatNumber(derCashInformation?.internal.cashWithdrawable)}</p>
          </div>
          <div className={styles.body}>
            <p>{t('Cash at VSD')}</p>
            <p>{formatNumber(derCashInformation?.exchange.cash)}</p>
          </div>
          <div className={styles.body}>
            <p>{t('Initial Margin')}</p>
            <p>{formatNumber(derportfolio?.internal.initialMargin)}</p>
          </div>
          <div className={styles.body}>
            <p>{t('Total Gain/loss')}</p>
            <p>{formatNumber(derAccountSummary?.totalPL)}</p>
          </div>
          <div className={styles.body}>
            <p>
              <i>{t('Unrealized Gain/Loss')}</i>
            </p>
            <p>
              {this.formatNumberHaveSlash(
                derAccountSummary?.floatingPL_tradingPL,
                'left'
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>
              <i>{t('Realized Gain/loss')}</i>
            </p>
            <p>
              {this.formatNumberHaveSlash(
                derAccountSummary?.floatingPL_tradingPL,
                'right'
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('Commission')}</p>
            <p>
              {this.formatNumberHaveSlash(
                derAccountSummary?.commission_tax,
                'left'
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('Tax + VSD Fee')}</p>
            <p>
              {this.formatNumberHaveSlash(
                derAccountSummary?.commission_tax,
                'right'
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('Margin Requirement')}</p>
            <p>
              {this.foundMaxNumber(
                derportfolio?.internal.marginReq,
                derportfolio?.exchange.marginReq
              )}
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('Account Ratio')}</p>
            <p>
              {this.foundMaxNumber(
                derportfolio?.internal.accountRatio,
                derportfolio?.exchange.accountRatio,
                3
              )}
              %
            </p>
          </div>
          <div className={styles.body}>
            <p>{t('Margin Call')}</p>
            <p>
              {this.foundMaxNumber(
                derportfolio?.internal.marginCall,
                derportfolio?.exchange.marginCall
              )}
            </p>
          </div>
        </div>
      </div>
    ) : (
      <div className={styles.TabAssetInfoDerNew}>
        <div className={styles.flex}>
          <div className={styles.TabAssetLeft}>
            <div className={styles.AccountInfo}>
              <div className={`${styles.Row} ${styles.mb20}`}>
                <span>{t('Account')}</span>
                <span>
                  <AccountDropdown />
                </span>
              </div>
              <div className={styles.Row}>
                <span>{t('Net asset value')}</span>
                <span>{formatNumber(derAccountSummary?.totalEquity)}</span>
              </div>
              <div className={styles.Row}>
                <span>{t('Account Balance')}</span>
                <span>{formatNumber(derAccountSummary?.accountBalance)}</span>
              </div>
              <div className={styles.Row}>
                <span>{t('Buying power')}</span>
                <span>
                  {(derCashInformation?.internal.EE ?? 0) < 0
                    ? 0
                    : formatNumber(derCashInformation?.exchange.EE)}
                </span>
              </div>
              <div className={styles.Row}>
                <span>{t('RC call')}</span>
                <span>{formatNumber(derAccountSummary?.rcCall)}</span>
              </div>
              <div className={styles.Row1}>
                <span onClick={this.onRefresh}>
                  <Refresh size={14} />
                  {t('Refresh')}
                </span>
              </div>
              {/* Account_Summary */}
              <div className={styles.Title}>
                <span>{t('Account Summary')}</span>
              </div>
              {/* Block_1 */}
              <div className={styles.Block}>
                <div className={styles.Box}>
                  <div className={styles.Row}>
                    <span>{t('Floating PL')}</span>
                    <span>
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.floatingPL_tradingPL,
                        'left'
                      )}
                    </span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Trading P/L')}</span>
                    <span>
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.floatingPL_tradingPL,
                        'right'
                      )}
                    </span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Total P/L')}</span>
                    <span>{formatNumber(derAccountSummary?.totalPL)}</span>
                  </div>
                </div>
              </div>
              {/* Block_2 */}
              <div className={styles.Block}>
                <div className={styles.Box}>
                  <div className={styles.Row}>
                    <span>{t('Commision')}</span>
                    <span>
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.commission_tax,
                        'left'
                      )}
                    </span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Tax 1')}</span>
                    <span>
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.commission_tax,
                        'right'
                      )}
                    </span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Interest 2')}</span>
                    <span>{formatNumber(derAccountSummary?.interest)}</span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Delivery Amount')}</span>
                    <span>{derAccountSummary?.deliveryAmount}</span>
                  </div>
                </div>
              </div>
              {/* Block_3 */}
              <div className={styles.Block}>
                <div className={styles.Box}>
                  <div className={styles.Row}>
                    <span>{t('Min Reserv')}</span>
                    <span>{formatNumber(derAccountSummary?.minReserve)}</span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Marginable')}</span>
                    <span>{formatNumber(derAccountSummary?.marginable)}</span>
                  </div>
                </div>
              </div>
              {/* Block_4 */}
              <div className={styles.Block}>
                <div className={styles.Box}>
                  <div className={styles.Row}>
                    <span>{t('Cash 1')}</span>
                    <span>
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.cash_nonCash,
                        'left'
                      )}
                    </span>
                  </div>
                  <div className={styles.Row}>
                    <span>{t('Non cash')}</span>
                    <span>
                      {' '}
                      {this.formatNumberHaveSlash(
                        derAccountSummary?.cash_nonCash,
                        'right'
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.TabAssetRight}>
            {/* Portfolio_Assessment */}
            <div className={styles.Title}>
              <span>{t('Porfolio Assessment')}</span>
            </div>

            <div className={styles.gridContainer}>
              <span className={styles.width50percent}></span>
              <span className={styles.internalTitle}>{t('Internal')}</span>
              <span className={styles.exchangeTitle}>{t('Exchange')}</span>

              {/* Initial_margin */}
              <span className={styles.gridRowTitle1}>
                {t('Initial Margin')}
                <OverlayTrigger
                  key={'initial-magin'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-initial-magin`}
                    >
                      {t('Initial margin tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal1}>
                {formatNumber(derportfolio?.internal.initialMargin)}
              </span>

              {/* Spread_margin */}
              <span className={styles.gridRowTitle}>
                {t('Spread Margin')}
                <OverlayTrigger
                  key={'spread'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-spread`}
                    >
                      {t('Spread margin tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derportfolio?.internal.spreadMargin)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derportfolio?.exchange.spreadMargin)}
              </span>

              {/* Delivery_margin */}
              <span className={styles.gridRowTitle}>
                {t('Delivery Margin')}
                <OverlayTrigger
                  key={'delivery'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-delivery`}
                    >
                      {t('Delivery margin tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derportfolio?.internal.deliveryMargin)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derportfolio?.exchange.deliveryMargin)}
              </span>
              {/* Margin_req */}
              <span className={styles.gridRowTitle}>
                {t('Margin Req')}
                <OverlayTrigger
                  key={'margin-req'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-margin-req`}
                    >
                      {t('Margin requirement tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derportfolio?.internal.marginReq)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derportfolio?.internal.marginReq)}
              </span>
              {/* Account_ratio */}
              <span className={styles.gridRowTitle}>{t('Account Ratio')}</span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derportfolio?.internal.accountRatio, 2)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derportfolio?.exchange.accountRatio, 2)}
              </span>
              {/* Warning_123 */}
              <span className={styles.gridRowTitle}>
                {t('Warning 1/2/3')}
                <OverlayTrigger
                  key={'warning'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-warning`}
                    >
                      {t('Warning123 tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal}>
                {derportfolio?.internal.warning123}
              </span>
              <span className={styles.gridRowExchange}>
                {derportfolio?.exchange.warning123}
              </span>
              {/* Margin_Call */}
              <span className={styles.gridRowTitle}>
                {t('Margin call')}
                <OverlayTrigger
                  key={'margin-call'}
                  placement="top"
                  overlay={
                    <Tooltip
                      className={styles.tooltipContainer}
                      id={`tooltip-margin-call`}
                    >
                      {t('Shortage margin requirement tooltip')}
                    </Tooltip>
                  }
                >
                  <InfoBuyIn width={15} />
                </OverlayTrigger>
              </span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derportfolio?.internal.marginCall)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derportfolio?.exchange.marginCall)}
              </span>
            </div>
            {/* Cash_Information */}
            <div className={styles.Title}>
              <span>{t('Cash Information')}</span>
            </div>

            <div className={styles.gridContainer}>
              <span className={styles.width50percent}></span>
              <span className={styles.internalTitle}>{t('Internal')}</span>
              <span className={styles.exchangeTitle}>{t('Exchange')}</span>

              {/* Cash */}
              <span className={styles.gridRowTitle}>{t('Cash')}</span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derCashInformation?.internal.cash)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derCashInformation?.exchange.cash)}
              </span>

              {/* Total_value */}
              <span className={styles.gridRowTitle}>{t('Total Value')}</span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derCashInformation?.internal.totalValue)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derCashInformation?.exchange.totalValue)}
              </span>
              {/* Cash Withdrawable */}
              <span className={styles.gridRowTitle}>
                {t('Cash Withdrawable')}
              </span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derCashInformation?.internal.cashWithdrawable)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derCashInformation?.exchange.cashWithdrawable)}
              </span>
              {/* EE */}
              <span className={styles.gridRowTitle}>{t('EE')}</span>
              <span className={styles.gridRowInternal}>
                {formatNumber(derCashInformation?.internal.EE)}
              </span>
              <span className={styles.gridRowExchange}>
                {formatNumber(derCashInformation?.exchange.EE)}
              </span>
            </div>

            <div className={styles.PortfolioTabs}>
              <div
                onClick={() => this.onClickTab(AssetInfoDerTabs.PORTFOLIO)}
                className={classNames(styles.TabName, {
                  [styles.Active]:
                    this.state.activeTab === AssetInfoDerTabs.PORTFOLIO,
                })}
              >
                <span>{t('Portfolio 2')}</span>
              </div>
              <div
                onClick={() =>
                  this.onClickTab(AssetInfoDerTabs.REALIZED_PORTFOLIO)
                }
                className={classNames(styles.TabName, {
                  [styles.Active]:
                    this.state.activeTab ===
                    AssetInfoDerTabs.REALIZED_PORTFOLIO,
                })}
              >
                <span>{t('Realized Portfolio')}</span>
              </div>
            </div>
            {/* SheetData_Table */}
            {this.state.activeTab === AssetInfoDerTabs.PORTFOLIO ? (
              <Portfolio isAssetComponent={true} />
            ) : (
              <RealizedPortfolio isAssetComponent={true} />
            )}
          </div>
        </div>
      </div>
    );
  }

  private onRefresh = () => {
    if (this.props.selectedAccount) {
      this.props.enquiryPortfolio({
        accountNumber: this.props.selectedAccount.accountNumber,
        type: this.props.selectedAccount.type,
      });
    }
  };

  private onClickTab = (tab: AssetInfoDerTabs) => {
    this.setState({
      activeTab: tab,
    });
  };

  private foundMinEE = (EeInternal?: number, EeExchange?: number) => {
    return formatNumber(Math.min(Number(EeInternal), Number(EeExchange)));
  };

  private foundMaxNumber = (
    Internal?: number,
    Exchange?: number,
    round?: number
  ) => {
    return formatNumber(Math.max(Number(Internal), Number(Exchange)), round);
  };

  // private formatNumberCell = (title: String, value?: Number | String) => {
  //   return typeof value === 'string'
  //     ? value
  //     : title === 'Account Ratio'
  //     ? `${formatNumber(Number(value), 2, undefined, undefined, '--')} %`
  //     : formatNumber(Number(value), 2, undefined, undefined, '--');
  // };

  private formatNumberHaveSlash = (
    val?: number | string,
    side?: string,
    title?: string
  ) => {
    if (typeof val === 'string' && val.indexOf('/')) {
      const locationSlash = val.indexOf('/');
      const stringCut = val.slice(0, locationSlash);
      if (side === 'left') {
        return formatNumber(Number(stringCut));
      }
      if (side === 'right') {
        return formatNumber(Number(val.slice(locationSlash + 1)));
      }
      if (title === 'Floating/Trading P/L') {
        return (
          <div>
            <span
              className={classNames({
                [globalStyles.Up]: Number(stringCut) > 0,
                [globalStyles.Down]: Number(stringCut) < 0,
              })}
            >
              {formatNumber(Number(stringCut))}
            </span>
            <span> / </span>
            <span
              className={classNames({
                [globalStyles.Up]: Number(val.slice(locationSlash + 1)) > 0,
                [globalStyles.Down]: Number(val.slice(locationSlash + 1)) < 0,
              })}
            >
              {formatNumber(Number(val.slice(locationSlash + 1)))}
            </span>
          </div>
        );
      }
      return `${formatNumber(Number(stringCut))} / ${formatNumber(
        Number(val.slice(locationSlash + 1))
      )}`;
    }
    if (title === 'Total P/L') {
      return (
        <span
          className={classNames({
            [globalStyles.Up]: Number(val) > 0,
            [globalStyles.Down]: Number(val) < 0,
          })}
        >
          {formatNumber(Number(val))}
        </span>
      );
    }
    return formatNumber(Number(val));
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  assetInforDerivatives: state.assetInforDerivatives,
});

const mapDispatchToProps = {
  getAssetInforDerivatives,
  enquiryPortfolio,
};

const AssetInforDerivatives = withRouter(
  withErrorBoundary(
    withNamespaces('common')(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AssetInforDerivativesComponent)
    ),
    Fallback,
    handleError
  )
);

export default AssetInforDerivatives;



// WEBPACK FOOTER //
// ./src/components/areas/Account/AssetInformation/AssetInforDerivatives/index.tsx